<template>
  <div class="step-outer-box">
    <ChapterFilter v-if="chapterDetail" :theme="chapterDetail.theme"></ChapterFilter>
    <div class="bottom-all-box">
      <div class="step-profile" v-if="chapterDetail.task_description">
        <div class="profile-label">虚拟展厅云游</div>
        <div class="profile-content">
          {{ chapterDetail.task_description }}
        </div>
      </div>
      <template>
        <div class="step-links" v-if="linkList&&linkList.length>0">
          <div class="link-item" v-for="item,index in linkList" :key="index" :class="[item.is_finish == 2?'success':'']" @click="handleClick(item)">
            <div class="link-cover">
              <div class="link-img" :style="`background:url(${item.cover})no-repeat center/cover`"></div>
              <div class="link-button">开始云游 ></div>
            </div>
            <div class="link-name">
              <p class="link-name-text">
                {{ item.name }}
              </p>
            </div>
          </div>
          <div class="flex-visible"></div>
          <div class="flex-visible"></div>
        </div>
        <template v-else>
          <a-empty />
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import ChapterFilter from '../../../components/student/ChapterFilter'
import services from '../../../assets/js/services';
import { mapState } from "vuex"
export default {
  name: 'stepTwo',
  components: {
    ChapterFilter
  },
  data () {
    return {
      school_code: localStorage.getItem("schoolCode"),
      linkList: [],
      chapterDetail: {},
    }
  },
  mounted () {
    this.$watch('$route', this.getTaskData, { immediate: true });
  },
  computed: {
    ...mapState({
      appsUserInfo: state => state.appsLogin.appsUserInfo,
    }),
  },
  methods: {
    async handleClick (item) {
      let query = this.$route.query
      let params = {
        activity_id: query.activity_id,
        course_id: query.course_id,
        chapter_id: query.chapter_id,
        school_id: this.appsUserInfo.school_id,
        course_hall_id: item.id,
        user_id: this.appsUserInfo.id,
      }
      // window.open(item.url, "_blank", "noopener,noreferrer,resizable")
      window.open('javascript:window.name;', '<script>location.replace("'+item.url+'")<\/script>'); // eslint-disable-line
      
      let result = await services.sutmitT002(params) // 提交学习
      if (result.code == "0000") {
        this.getTaskData() // 更新列表完成状态
      }
    },
    async getTaskData () {
      let query = this.$route.query
      let params = {
        code: "t002",
        activity_id: query.activity_id,
        course_id: query.course_id,
        chapter_id: query.chapter_id
      }
      let result = await services.getCenterTaskData(params)
      if (result.code == '0000') {
        this.chapterDetail = result.data.chapter
        this.linkList = result.data.course_halls
      }
    }
  }
}
</script>

<style lang="less" scoped>
.step-outer-box {
    width: 100%;
    .bottom-all-box {
        border: 1px solid #e7eaec;
        padding: 18px 25px 0;
        position: relative;
        overflow-y: auto;
        height: calc(100vh - 200px);
        min-height: 700px;
        .submit-box {
            width: 100%;
            position: sticky;
            bottom: 0;
            left: 0;
            z-index: 10;
            padding: 20px 25px;
            text-align: center;
            border-top: 1px solid #ebedef;
            background: #ffffff;
            box-sizing: border-box;
            .submit-btn {
                cursor: pointer;
                margin: 0 auto;
                width: 88px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                background: #a82822;
                font-size: 14px;
                color: #ffffff;
            }
        }
        .step-profile {
            display: flex;
            .profile-label {
                width: 112px;
                height: 28px;
                background: #bc7a6e;
                border-radius: 14px 0px 0px 14px;
                text-align: center;
                line-height: 28px;
                font-weight: bold;
                font-size: 14px;
                color: #ffffff;
                padding: 0 14px;
            }
            .profile-content {
                flex: 1;
                background: #fcf2f0;
                border-radius: 4px;
                font-size: 14px;
                color: #2f2626;
                line-height: 18px;
                height: max-content;
                padding: 5px 14px;
                max-height: 120px;
                overflow-y: auto;
            }
        }
        .step-links {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            padding-top: 25px;
            padding-right: 60px;
            .flex-visible {
                display: inline-block;
                flex: 0 0 296px;
                visibility: hidden;
            }
            .link-item {
                width: 296px;
                cursor: pointer;
                margin-bottom: 26px;

                .link-cover {
                    width: 100%;
                    height: 167px;
                    overflow: hidden;
                    position: relative;
                    &::before {
                        content: '';
                        display: inline-block;
                        position: absolute;
                        top: 8px;
                        right: 8px;
                        width: 24px;
                        height: 24px;
                        background: url('../../../assets/image/student/stepTwo/success.png')
                            no-repeat center/cover;
                        opacity: 0;
                        z-index: 1;
                    }
                    .link-img {
                        width: 100%;
                        height: 100%;
                        transition: all 0.3s;
                    }
                    .link-button {
                        width: 100px;
                        height: 32px;
                        background: rgba(255, 234, 179, 0.94);
                        border-radius: 16px 0px 0px 16px;
                        text-align: center;
                        line-height: 32px;
                        font-size: 14px;
                        color: #892018;
                        position: absolute;
                        bottom: 20px;
                        right: 0;
                    }
                }
                .link-name {
                    width: 100%;
                    height: 62px;
                    background: #ffffff;
                    border: 1px solid #e7eaec;
                    padding: 10px 18px;
                    font-size: 14px;
                    color: #3c3c3e;
                    line-height: 20px;
                    transition: all 0.3s;
                    .link-name-text {
                        display: block;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                    }
                }
                &:hover {
                    .link-cover .link-img {
                        transform: scale(1.1);
                    }
                    .link-name {
                        color: #a82822;
                        background: #fff3f2;
                    }
                }
                &.success .link-cover::before {
                    opacity: 1;
                }
            }
        }
    }
}
</style>